<template>
  <div class="text-center">
    <div class="mb-4">
      <Icon
        :size="40"
        icon="link-variant-remove"
      />
    </div>
    <h2 style="color: #444">
      {{ $t('emptyLink.noResults') }}
    </h2>
    <h3 class="font-weight-regular text--secondary mb-5">
      {{ $t('emptyLink.message1') }}
    </h3>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class Empty extends Vue {}
</script>
